function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTriangle = function SvgTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 384 400",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.978,115.874l-10.794,-8.705l-7.129,-0.608l-0.361,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.975,115.878l-9.872,-9.739l-1.412,-7.013l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.752,27.2l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.749,27.204l-9.872,-9.739l-1.412,-7.013l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.529,159.261l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.525,159.265l-9.872,-9.739l-1.412,-7.013l5.812,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.302,70.587l-10.794,-8.705l-7.129,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.299,70.591l-9.872,-9.739l-1.412,-7.013l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.024,93.574l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.021,93.577l-9.872,-9.738l-1.412,-7.014l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.798,4.899l-10.795,-8.704l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.794,4.903l-9.872,-9.738l-1.412,-7.014l5.812,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.574,136.961l-10.794,-8.705l-7.129,-0.608l-0.361,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.571,136.964l-9.872,-9.738l-1.412,-7.014l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.348,48.287l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.344,48.29l-9.872,-9.738l-1.411,-7.014l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.175,292.93l-10.794,-8.705l-7.129,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.172,292.934l-9.872,-9.739l-1.412,-7.013l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.949,204.256l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.945,204.26l-9.872,-9.739l-1.411,-7.013l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M403.725,336.317l-10.794,-8.705l-7.129,-0.608l-0.361,5.891",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.499,247.643l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.496,247.647l-9.872,-9.739l-1.412,-7.013l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.221,270.63l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.217,270.633l-9.872,-9.738l-1.411,-7.014l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.995,181.956l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.991,181.959l-9.872,-9.738l-1.412,-7.014l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.771,314.017l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.768,314.021l-9.872,-9.739l-1.412,-7.014l5.811,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M279.545,225.343l-10.795,-8.705l-7.128,-0.608l-0.362,5.89",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.541,225.346l-9.872,-9.738l-1.412,-7.014l5.812,-1.027",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.446,44.85l16.673,4.835",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.286,33.651l6.94,15.913",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.055,46.477l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.621,39.005l-19.354,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.99,57.613c0.208,0.182 0.23,0.497 0.051,0.701c-0.18,0.205 -0.494,0.222 -0.702,0.04c-0.208,-0.183 -0.231,-0.497 -0.051,-0.702c0.179,-0.204 0.494,-0.222 0.702,-0.039Z",
    className: "main",
    style: {
      fill: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.002,11.071l16.674,4.835",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.842,-0.128l6.94,15.913",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.612,12.698l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.177,5.226l-19.353,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.546,23.834c0.208,0.182 0.231,0.497 0.051,0.701c-0.18,0.204 -0.494,0.222 -0.702,0.04c-0.208,-0.183 -0.231,-0.497 -0.051,-0.702c0.18,-0.204 0.494,-0.222 0.702,-0.039Z",
    className: "main",
    style: {
      fill: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.33,79.895l16.674,4.835",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.17,68.696l6.94,15.913",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94,81.522l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.505,74.05l-19.353,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.874,92.658c0.208,0.182 0.231,0.497 0.051,0.701c-0.18,0.204 -0.494,0.222 -0.702,0.04c-0.208,-0.183 -0.231,-0.497 -0.051,-0.702c0.18,-0.204 0.494,-0.222 0.702,-0.039Z",
    className: "main",
    style: {
      fill: "#fff",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.875,115.039l16.674,4.836",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.715,103.841l6.94,15.912",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.485,116.666l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.05,109.194l-19.353,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.419,127.802c0.208,0.183 0.231,0.497 0.051,0.701c-0.179,0.205 -0.494,0.223 -0.702,0.04c-0.207,-0.183 -0.23,-0.497 -0.051,-0.701c0.18,-0.205 0.495,-0.222 0.702,-0.04Z",
    className: "main",
    style: {
      fill: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M335.204,183.863l16.673,4.835",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.044,172.665l6.939,15.912",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.813,185.49l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.378,178.018l-19.353,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.747,196.626c0.208,0.183 0.231,0.497 0.051,0.701c-0.179,0.205 -0.494,0.223 -0.702,0.04c-0.207,-0.183 -0.23,-0.497 -0.051,-0.701c0.18,-0.205 0.495,-0.222 0.702,-0.04Z",
    className: "main",
    style: {
      fill: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.76,150.084l16.673,4.835",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,138.885l6.94,15.913",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.369,151.711l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.935,144.239l-19.354,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.304,162.847c0.207,0.183 0.23,0.497 0.051,0.701c-0.18,0.205 -0.495,0.223 -0.702,0.04c-0.208,-0.183 -0.231,-0.497 -0.051,-0.701c0.179,-0.205 0.494,-0.222 0.702,-0.04Z",
    className: "main",
    style: {
      fill: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375.088,218.908l16.673,4.835",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.928,207.709l6.94,15.913",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.697,220.535l-6.857,-18.626",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.263,213.063l-19.353,-4.404",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.749,24.491l-17.812,1.947c0,0 9.23,5.662 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.93,26.336l17.812,-1.947c0,0 -9.23,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.109,24.508l17.912,-0.468c0,0 -8.384,6.854 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.014,23.938l-17.912,0.468c0,0 8.384,-6.853 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.365,6.116l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.935,24.021l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.934,24.935l0.468,17.912c0,0 -6.853,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.504,42.84l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.829,-17.05l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.399,0.856l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.769,45.454l-17.812,1.948c0,0 9.23,5.662 17.812,-1.948Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.95,47.3l17.812,-1.947c0,0 -9.23,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.129,45.472l17.912,-0.468c0,0 -8.384,6.854 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.034,44.902l-17.912,0.468c0,0 8.384,-6.853 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.385,27.079l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.955,44.985l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.954,45.899l0.468,17.912c0,0 -6.853,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.524,63.804l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.842,3.626l-17.812,1.947c0,0 9.23,5.663 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.023,5.471l17.812,-1.947c0,0 -9.23,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.202,3.643l17.912,-0.468c0,0 -8.384,6.854 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.107,3.073l-17.912,0.469c0,0 8.384,-6.854 17.912,-0.469Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.458,-14.749l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.028,3.156l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.027,4.07l0.469,17.912c0,0 -6.854,-8.384 -0.469,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.597,21.975l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.968,66.574l-17.812,1.947c0,0 9.23,5.663 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.149,68.419l17.812,-1.947c0,0 -9.231,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M276.328,66.592l17.912,-0.468c0,0 -8.384,6.853 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.233,66.022l-17.912,0.468c0,0 8.384,-6.854 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.583,48.199l0.468,17.912c0,0 -6.853,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.153,66.104l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M276.153,67.018l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.723,84.923l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.791,89.692l-17.812,1.947c0,0 9.23,5.663 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.972,91.537l17.812,-1.947c0,0 -9.23,-5.662 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.151,89.71l17.912,-0.468c0,0 -8.384,6.853 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.056,89.14l-17.912,0.468c0,0 8.384,-6.854 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.407,71.317l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.977,89.222l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.977,90.136l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.546,108.042l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.917,152.64l-17.812,1.947c0,0 9.23,5.663 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.098,154.486l17.812,-1.947c0,0 -9.23,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M373.277,152.658l17.912,-0.468c0,0 -8.384,6.854 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.182,152.088l-17.912,0.468c0,0 8.384,-6.853 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.533,134.265l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.102,152.171l-0.468,-17.913c0,0 6.854,8.385 0.468,17.913Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M373.102,153.085l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.672,170.99l-0.468,-17.912c0,0 6.853,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M324.811,110.656l-17.812,1.947c0,0 9.23,5.663 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.992,112.501l17.812,-1.947c0,0 -9.23,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.171,110.673l17.912,-0.468c0,0 -8.384,6.854 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.076,110.104l-17.912,0.468c0,0 8.384,-6.854 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M324.427,92.281l0.468,17.912c0,0 -6.853,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.997,110.186l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M324.997,111.1l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.566,129.005l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.937,173.604l-17.812,1.947c0,0 9.23,5.663 17.812,-1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.118,175.45l17.812,-1.948c0,0 -9.23,-5.662 -17.812,1.948Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.01,131.775l-17.812,1.948c0,0 9.23,5.662 17.812,-1.948Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.191,133.621l17.812,-1.947c0,0 -9.23,-5.663 -17.812,1.947Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.37,131.793l17.912,-0.468c0,0 -8.384,6.854 -17.912,0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.275,131.223l-17.912,0.468c0,0 8.384,-6.853 17.912,-0.468Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.626,113.4l0.468,17.912c0,0 -6.854,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.195,131.306l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.195,132.22l0.468,17.912c0,0 -6.853,-8.384 -0.468,-17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.765,150.125l-0.468,-17.912c0,0 6.854,8.384 0.468,17.912Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 1
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.048,25.834c-7.509,-3.692 -3.252,-19.315 -4.591,-23.377c-2.037,-6.176 -10.973,-5.926 -8.929,-3.715c1.579,1.708 3.524,5.209 2.549,7.614c-1.452,3.584 -3.543,6.221 -8.309,2.952c-3.636,-2.494 -3.022,-13.574 -4.39,-23.391c-1.089,-7.823 -12.279,-6.389 -8.77,-4.359c4.395,2.543 3.213,6.709 3.157,7.095c-0.152,1.063 -4.593,6.374 -9.257,2.855c-4.109,-3.101 -2.885,-19.581 -4.285,-24.773c-1.273,-4.72 -7.937,-7.884 -10.742,-4.942c-1.681,1.762 6.072,0.666 5.214,6.899c-0.859,6.233 -8.036,6.573 -9.657,4.986",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.132,78.877c-5.258,-1.59 -4.51,-19.846 -5.608,-24.217c-1.586,-6.307 -10.973,-5.926 -8.93,-3.715c1.58,1.708 3.524,5.209 2.55,7.614c-1.452,3.585 -3.543,6.221 -8.309,2.952c-3.636,-2.494 -3.023,-13.574 -4.39,-23.391c-1.09,-7.823 -12.279,-6.389 -8.77,-4.359c4.394,2.543 3.212,6.709 3.157,7.095c-0.153,1.063 -4.594,6.374 -9.257,2.855c-4.109,-3.101 -2.885,-19.581 -4.285,-24.772c-1.273,-4.721 -7.938,-7.884 -10.743,-4.943c-1.68,1.762 6.073,0.667 5.214,6.899c-0.858,6.233 -8.035,6.573 -9.656,4.986",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M217.773,130.812c-7.509,-3.692 -3.252,-19.315 -4.591,-23.376c-2.037,-6.177 -10.973,-5.926 -8.929,-3.716c1.579,1.709 3.524,5.209 2.549,7.614c-1.452,3.585 -3.543,6.222 -8.309,2.952c-3.636,-2.494 -3.022,-13.574 -4.39,-23.391c-1.089,-7.823 -12.279,-6.389 -8.77,-4.358c4.395,2.543 3.213,6.708 3.157,7.095c-0.152,1.062 -4.593,6.373 -9.257,2.854c-4.109,-3.1 -2.885,-19.581 -4.285,-24.772c-1.273,-4.721 -7.937,-7.884 -10.742,-4.943c-1.681,1.762 6.072,0.667 5.214,6.9c-0.859,6.232 -8.036,6.573 -9.657,4.985",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.992,183.238c-2.54,-1.446 -2.676,-18.945 -4.743,-23.599c-2.641,-5.944 -10.973,-5.926 -8.93,-3.716c1.58,1.709 3.524,5.209 2.55,7.615c-1.452,3.584 -3.543,6.221 -8.309,2.951c-3.636,-2.494 -3.023,-13.574 -4.39,-23.391c-1.09,-7.823 -12.279,-6.389 -8.77,-4.358c4.394,2.543 3.212,6.708 3.157,7.095c-0.153,1.062 -4.594,6.373 -9.257,2.854c-4.109,-3.1 -2.885,-19.58 -4.285,-24.772c-1.273,-4.721 -7.938,-7.884 -10.743,-4.943c-1.68,1.762 6.072,0.667 5.214,6.9c-0.858,6.233 -8.035,6.573 -9.656,4.985",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M334.585,235.546c-7.517,-3.676 -3.294,-19.308 -4.643,-23.367c-2.051,-6.171 -10.985,-5.901 -8.937,-3.696c1.583,1.706 3.535,5.202 2.566,7.609c-1.444,3.588 -3.529,6.229 -8.303,2.97c-3.641,-2.486 -3.052,-13.567 -4.441,-23.381c-1.107,-7.821 -12.293,-6.362 -8.78,-4.339c4.4,2.533 3.228,6.701 3.173,7.088c-0.15,1.063 -4.579,6.383 -9.25,2.875c-4.116,-3.092 -2.929,-19.575 -4.34,-24.763c-1.283,-4.718 -7.955,-7.867 -10.754,-4.919c-1.676,1.766 6.074,0.653 5.23,6.888c-0.845,6.234 -8.021,6.59 -9.646,5.007",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.786,288.459c-5.262,-1.579 -4.554,-19.836 -5.662,-24.204c-1.6,-6.304 -10.986,-5.902 -8.938,-3.697c1.583,1.706 3.536,5.202 2.567,7.609c-1.445,3.588 -3.53,6.229 -8.303,2.97c-3.642,-2.486 -3.052,-13.567 -4.441,-23.381c-1.107,-7.821 -12.293,-6.362 -8.78,-4.339c4.4,2.533 3.227,6.701 3.173,7.088c-0.151,1.063 -4.58,6.383 -9.251,2.875c-4.116,-3.092 -2.928,-19.575 -4.34,-24.763c-1.283,-4.718 -7.955,-7.867 -10.753,-4.919c-1.677,1.766 6.074,0.653 5.229,6.888c-0.844,6.235 -8.021,6.59 -9.646,5.007",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.762,-10.691l-0.58,15.547l103.248,-24.534",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.642,115.656l-15.349,2.536l20.845,-105.064",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.991,2.745l1.977,15.431l91.965,-35.82",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.356,104.405l-15.558,-0.014l30.797,-94.883",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.389,15.439l4.1,15.007l81.283,-45.617",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.016,94.061l-15.405,-2.174l40.19,-86.689",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.025,28.394l6.133,14.298l71.465,-54.65",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.585,83.906l-14.958,-4.28l49.327,-77.963",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.695,41.148l7.854,13.43l63.083,-63.305",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.066,74.112l-14.313,-6.096l56.788,-70.814",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.964,49.158l0.878,11.576l11.17,-0.097",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 2
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/triangle.e994e39d.svg";
export { ForwardRef as ReactComponent };